import 'bootstrap/dist/css/bootstrap-grid.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.scss';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core/styles';
import App from './App';
import * as serviceWorker from './serviceWorker';
import CommonTheme from './CommonTheme';
import { ApolloWrapper } from 'utils/ApolloWrapper';

const rootEl = document.getElementById('root');

if (!window.GLOBAL_CONFIG.GRAPHQL_URL) {
  throw new Error(
    'GRAPHQL_URL is missing in global config. Probably global-config.json volume is not mounted into investapp',
  );
}

render(App);
if (module.hot) {
  module.hot.accept('./App', () => {
    render(require('./App').default);
  });
}

function render(AppComponent: React.FunctionComponent) {
  ReactDOM.render(
    <ThemeProvider theme={CommonTheme}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <BrowserRouter>
          {/* @ts-ignore */}
          <ApolloWrapper graphqlUrl={window.GLOBAL_CONFIG.GRAPHQL_URL}>
            <AppComponent />
          </ApolloWrapper>
        </BrowserRouter>
      </MuiPickersUtilsProvider>
    </ThemeProvider>,
    rootEl,
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
